export default {
      id: "telegram-usage",
      viewBox: "0 0 25 25",
      url: __webpack_public_path__ + "img/icons.svg#telegram",
      toString: function () {
        return this.url;
      }
    }